import { Box, Grid, Typography, useTheme } from "@mui/material";
import Carousel from "../carousel/Carousel";

interface VehicleMediaDisplayProps {
  clientId: string;
  assetId: string;
  visibleTypes: { [key: string]: boolean };
  imageCategories: { key: string; label: string; images: any[] }[];
}

const VehicleMediaDisplay: React.FC<VehicleMediaDisplayProps> = ({
  clientId,
  assetId,
  visibleTypes,
  imageCategories,
}) => {
  const theme = useTheme();

  return (
    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
      {imageCategories.map(({ key, label, images }) => {
        if (!visibleTypes[key] || images.length === 0) return null;

        // 🧠 Logic: make undercarriage full-width if it has multiple images
        const isUndercarriage =
          label.toLowerCase().includes("undercarriage") ||
          key.toLowerCase().includes("uc");

        const gridSize = isUndercarriage && images.length > 1 ? 12 : 6;

        return (
          <Grid item xs={12} md={gridSize} key={key}>
            <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
              <Typography variant="h6" gutterBottom>
                {label} Images
              </Typography>
              <Carousel images={images} />
            </Box>
          </Grid>
        );
      })}

      {/* iFrame (All) */}
      <Grid item xs={12} md={6}>
        <Typography variant="h6" gutterBottom>
          iFrame Preview (All)
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <iframe
            src={`/iframe/${clientId}/${assetId}`}
            width="100%"
            height="100%"
            style={{
              borderRadius: "10px",
              minHeight: "400px",
              border: "none",
            }}
            allow="fullscreen"
            allowFullScreen
          />
        </Box>
      </Grid>

      {/* iFrame (Exterior) */}
      <Grid item xs={12} md={6}>
        <Typography variant="h6" gutterBottom>
          iFrame Preview (Exterior)
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "90%",
          }}
        >
          <iframe
            src={`/iframe/${clientId}/${assetId}/ext-crop-feat`}
            width="100%"
            height="100%"
            style={{
              borderRadius: "10px",
              minHeight: "400px",
              alignContent: "center",
              border: "none",
            }}
            allow="fullscreen"
            allowFullScreen
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default VehicleMediaDisplay;
